// Posicionamiento popper-style hand-rolled (UX-DR9 / D4.5: no
// floating-ui, no popper). Reactividad ligera basada en `ref` +
// recompute on mount/show/scroll/resize.
//
// Contrato:
//   - Default placement: bottom (debajo del trigger).
//   - Edge-flip horizontal: si overflow al viewport derecho, mueve a
//     la izquierda; si al izquierdo, vuelve a derecha. Sin clip.
//   - Edge-flip vertical: si overflow abajo, lo flippeamos arriba.
//   - Offset: 8 px del trigger.
//   - El popover se teleportea a <body>, así que la posición se
//     calcula en coords absolute (page) — incluye scroll offset.

import { onBeforeUnmount, onMounted, reactive } from 'vue';

const OFFSET = 8;

export function useTooltipPosition(triggerRef, popoverRef, openRef) {
  const pos = reactive({ top: 0, left: 0, placement: 'bottom' });

  function recompute() {
    if (!openRef.value) return;
    const trigger = triggerRef.value;
    const popover = popoverRef.value;
    if (!trigger || !popover) return;

    const tRect = trigger.getBoundingClientRect();
    const pRect = popover.getBoundingClientRect();
    const vpW = window.innerWidth;
    const vpH = window.innerHeight;
    const scrollX = window.scrollX || window.pageXOffset || 0;
    const scrollY = window.scrollY || window.pageYOffset || 0;

    // Default: bottom-center alineado al trigger.
    let top = tRect.bottom + OFFSET;
    let left = tRect.left + tRect.width / 2 - pRect.width / 2;
    let placement = 'bottom';

    // Vertical flip: si no cabe abajo y sí arriba, flippear.
    if (top + pRect.height > vpH && tRect.top - OFFSET - pRect.height >= 0) {
      top = tRect.top - OFFSET - pRect.height;
      placement = 'top';
    }

    // Horizontal clamp + flip:
    if (left < 0) left = OFFSET;
    if (left + pRect.width > vpW) left = vpW - pRect.width - OFFSET;

    pos.top = top + scrollY;
    pos.left = left + scrollX;
    pos.placement = placement;
  }

  function onWindowChange() { recompute(); }

  onMounted(() => {
    window.addEventListener('scroll', onWindowChange, true);
    window.addEventListener('resize', onWindowChange);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', onWindowChange, true);
    window.removeEventListener('resize', onWindowChange);
  });

  return { pos, recompute };
}
